




import Vue from 'vue'

export default Vue.extend({
  name: 'MasterDataIndustrialTimeModelPage',

  data () {
    return {

    }
  },

  methods: {

  },
})
